export default "__VITE_ASSET__BGKvk3lg__"